export default { 
  h479a32ab389a0cd2f76c54276cddc1d6: [[({}, [C0]) => ["Try setting up", " ", C0(), " Login later under", " "], {}]],
  h5f120f311d800b722b5506b80649e66a: [[({}, []) => ["Got it"], {}]],
  h9d73f027d4f87e9695505c744f8b67a0: [[({}, []) => ["Oops! We couldn't enable Face ID Login."], {}]],
  he871b0059c7114c04a1127173dbe674b: [[({}, []) => ["Oops! We couldn't enable Fingerprint Login."], {}]] 
}